import { CADASTRO_MODELO, CadastroModeloReq, TYPES } from './types'
import { Paginacao } from 'models/types'
import store from 'store'

type ActiveTab = 'search' | 'register'
export const setActiveTab = (value: ActiveTab) => ({
  type: TYPES.SET_ACTIVE_TAB,
  value
})

type ActiveTabRegister = 1 | 2
export const setActiveTabRegister = (value: ActiveTabRegister) => ({
  type: TYPES.SET_ACTIVE_TAB_REGISTER,
  value
})

export const setPaginacao = (value: Paginacao) => ({
  type: TYPES.SET_PAGINATION,
  value
})

export const setPesquisa = (value: string | number | null, field: string) => ({
  type: TYPES.SET_PESQUISA,
  value,
  field
})

export const getAllModeloMensagemSaga = () => ({
  type: TYPES.GET_ALL_MODELO_MENSAGEM_SAGA
})

export const setAllCadastroModelo = (value: CadastroModeloReq[]) => ({
  type: TYPES.SET_ALL_CADASTRO_MODELO,
  value
})

export const toggleModalExclusaoDispatch = (value: boolean) =>
  store.dispatch({
    type: TYPES.TOGGLE_MODAL_EXCLUSAO_DISPATCH,
    value
  })

export const setItemSelectedIdDispatch = (value: string) =>
  store.dispatch({
    type: TYPES.SET_ITEM_SELECTED_ID_DISPATCH,
    value
  })

type RegisterFields = keyof CADASTRO_MODELO['register']
export const setRegisterFields = <T extends RegisterFields>(
  value: T extends keyof CADASTRO_MODELO['register']
    ? CADASTRO_MODELO['register'][T]
    : never,
  field: T
) => ({
  type: TYPES.SET_REGISTER_FIELDS,
  value,
  field
})

export const setRegister = (value: CadastroModeloReq) => ({
  type: TYPES.SET_REGISTER,
  value
})

export const cleanRegister = () => ({
  type: TYPES.CLEAN_REGISTER
})

export const cleanInvalids = () => ({
  type: TYPES.CLEAN_INVALIDS
})

type InvalidFields = keyof CADASTRO_MODELO['invalids']
export const setInvalids = <T extends InvalidFields>(
  value: T extends keyof CADASTRO_MODELO['invalids']
    ? CADASTRO_MODELO['invalids'][T]
    : never,
  field: T
) => ({
  type: TYPES.SET_INVALIDS,
  value,
  field
})

export const visualizarModeloMensagemSagaDispatch = (id: string) =>
  store.dispatch({
    type: TYPES.VISUALIZAR_MODELO_MENSAGEM_SAGA_DISPATCH,
    id
  })
export const editarModeloMensagemSagaDispatch = (id: string) =>
  store.dispatch({
    type: TYPES.EDITAR_MODELO_MENSAGEM_SAGA_DISPATCH,
    id
  })

export const setVisualizacao = (value: boolean) => ({
  type: TYPES.SET_VISUALIZACAO,
  value
})

export const criarModeloMensagemSaga = (data: CadastroModeloReq) => ({
  type: TYPES.CRIAR_MODELO_MENSAGEM_SAGA,
  data
})

export const atualizarModeloMensagemSaga = (
  data: CadastroModeloReq,
  id: string
) => ({
  type: TYPES.ATUALIZAR_MODELO_MENSAGEM_SAGA,
  data,
  id
})

export const deleteModeloMensagemSaga = (id: string) => ({
  type: TYPES.DELETE_MODELO_MENSAGEM_SAGA_DISPATCH,
  id
})

export const deleteCadastroSagaDispatch = () =>
  store.dispatch({
    type: TYPES.DELETE_MODELO_MENSAGEM_SAGA_DISPATCH
  })

export const getFiltrosSaga = () => ({
  type: TYPES.GET_FILTRO_CADASTRO_SAGA
})

export const getModelosMensagemSaga = () => ({
  type: TYPES.GET_MODELOS_MENSAGEM_SAGA
})

export const setModelosMensagemSelect = (value: CadastroModeloReq[]) => ({
  type: TYPES.SET_MODELOS_MENSAGEM_SELECT,
  value
})
